export const validLength = (value) => {
  return value.trim().length;
};

// Regex applicable to names and usual text but not for address
// Nor accepting numbers and special characters
export const validText = (value) => {
  //letter and special char
  const re = /[a-zA-Z]+(?:(?:\. |[' ])[a-zA-Z]+)*$/;
  return re.test(String(value).toLowerCase());
};

export const validNumber = (value) => {
  const re = /^[0-9]$/;
  return re.test(String(value).toLowerCase());
};

export const validMultipleNumber = (value, length) => {
  const re = new RegExp(`^[0-9]{${length}}$`);
  return re.test(String(value).toLowerCase());
};

export const validPhoneNumber = (value) => {
  const re = /^(([+]|00)39)?((3[1-9][0-9]))(\d{6,9})$/;
  // italian modile number regex: it does not accpet space

  // /^(\((00|\+)39\)|(00|\+)39)?(38[890]|34[7-90]|36[680]|33[3-90]|32[89])\d{7}$/;

  // const re = /^(\+|00){0,7}(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/
  return re.test(String(value).toLowerCase());
};

export const validAlphaNumeric = (value) => {
  //letter and number char
  const re = /[A-Za-z0-9]+$/;
  return re.test(String(value).toLowerCase());
};

export const validPiva = (value) => {
  const re = /^[0-9]{11}$/;
  return re.test(String(value).toLowerCase());
};

export const validIban = (value) => {
  const re =
    /IT[a-zA-Z0-9]{2}\s?([a-zA-Z]{1})([0-9]{3}\s?)([0-9]{4}\s?){1}([0-9]{3})([a-zA-Z0-9]{1}\s?)([a-zA-Z0-9]{4}\s?){2}([a-zA-Z0-9]{3})\s?/;
  // const re = /^IT\d{2}[ ][a-zA-Z]\d{3}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{4}[ ]\d{3}|IT\d{2}[a-zA-Z]\d{22}$/;
  return re.test(String(value).toUpperCase());
};

export const validCodiceFiscale = (value) => {
  // /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/
  const re =
    /^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$/;
  return re.test(String(value).toLowerCase());
};

export const validDate = (value) => {
  //format supported:
  // dd-mmm-YYYY, dd/mmm/YYYY, dd.mmm.YYYY
  const re =
    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
  return re.test(String(value).toLowerCase());
};

export const validURL = (value) => {
  const re =
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  return re.test(String(value).toLowerCase());
};

export const validZipCode = (value) => {
  const re = /^[0-9]{5}$/;
  return re.test(String(value).toLowerCase());
};

export const validEmail = (value) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};

export const validPsw = (value) => {
  const re =
    /^(?:(?=.*[a-z])(?:(?=.*[A-Z])(?=.*[\d\W])|(?=.*\W)(?=.*\d))|(?=.*\W)(?=.*[A-Z])(?=.*\d)).{8,}$/;
  return re.test(String(value).toLowerCase());
};

export const validCodiceRichiesta = (value) => {
  //letter and number char and 8 characters
  const re = /^[0-9]{8}$/;
  return re.test(String(value).toLowerCase());
};

export const validAddress = (value) => {
  // accepts letters, spaces, "," and numbers
  // Example tested: Vialle Jenner, 19 / Via San Calocero,4
  //const re = /^([A-Za-z]+\s?)+[\,]+(\s?[0-9]+)$/;
  const re = /^(([A-Za-z]+\s?)+)(\,?\s?[0-9A-Za-z]+)+(\s?[0-9A-Za-z]+)?/;
  return re.test(String(value).toLowerCase());
};

export const validSameValue = (value) => {
  const previousInput = document.querySelector("#email");
  return value === previousInput.value;
};

// Review validation for:
export const validRadioButtons = (name) => {
  const radioButtons = document.querySelectorAll(`input[name='${name}']`);

  for (const btn of radioButtons) {
    if (btn.checked) return true;
  }
};

export const validUpload = (event) => {
  const file = event.target.files[0];

  // accepts just files that start with words, mixed with numbers, space, "_", "-", "()", and followed by ".pdf"
  const re = /^[a-zA-Z0-9\-?\_?\s?\()?]+\.(png|jpg|pdf)$/;
  return re.test(String(file.name).toLowerCase());
};
